import { render, staticRenderFns } from "./EscolheVaras.vue?vue&type=template&id=309532c6&scoped=true"
import script from "./EscolheVaras.vue?vue&type=script&lang=js"
export * from "./EscolheVaras.vue?vue&type=script&lang=js"
import style0 from "./EscolheVaras.vue?vue&type=style&index=0&id=309532c6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "309532c6",
  null
  
)

export default component.exports